export default __webpack_public_path__ + "static/disaster-recovery-cloud-native-business-continuity-b3500d7ba54bc843ecfcebcd7b06065e.jpg";